// extracted by mini-css-extract-plugin
export default {"page":"W1-z","cartModal":"X1-z","checkout":"Y1-z","placeholder":"Z1-z","account":"_1-z"};